module.exports = __webpack_public_path__ + "static/media/caret-square-up.1982150c.svg";